export enum CompanyTypes {
  SUBSCRIPTION = 'subscription',
  FINTECH = 'fintech',
  ECOMMERCE = 'ecommerce',
  DIGITAL = 'digital',
}
